<script setup lang="ts">
import CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import { useUserRegistrationSuccessDialog } from '@/composables/userManagement/useUserRegistrationSuccessDialog'
import { useUserManagementStore } from '@/stores/userManagementStore'
import { storeToRefs } from 'pinia'

const { openDialog } = useUserRegistrationSuccessDialog()
const userManagementStore = useUserManagementStore()
const { registeredUserId } = storeToRefs(userManagementStore)

defineExpose({
  openDialog
})
</script>

<template>
  <CommonDialog size="md" ref="commonDialog" cancelTitle="閉じる" cancelOnly>
    <template #header> <h3 class="w-100 text-center">新規ユーザーが登録されました</h3></template>
    <div class="container">
      <div class="pb-3">ユーザーID：{{ registeredUserId }}</div>
      <div>このユーザーIDを団体管理者に伝えて、サインアップ手続きを依頼してください。</div>
    </div>
  </CommonDialog>
</template>

<style lang="scss" scoped></style>
